export default (axios, baseURL) => {
    return{
        //
        login(data){
            
            return axios.post(`${baseURL}/api/auth/login`, 
                data
            );
        },
    }
}